import VueI18n from 'vue-i18n'

const localTranslations = {
  en: {},
  de: {},
}

export function init() {
  return new VueI18n({
    locale: 'de',
    fallbackLocale: 'de',
    messages: localTranslations,
  })
}

export function updateTranslations(i18n, translations) {
  Object.keys(translations).forEach((language) => {
    i18n.setLocaleMessage(language, translations[language])
  })
}
